import { BankConnectionErrorType } from '../enums/bankConnectionErrorType'

type OpenBankingErrorType = BankConnectionErrorType.OpenBankingConnect | BankConnectionErrorType.OpenBankingMerge

export const openBankingErrorCommonKeys = {
  cta: 'close',
  title: 'bank_connection.connect_modal.open_banking.error_title',
} as const

export const openBankingErrorDescriptions: Record<OpenBankingErrorType, string> = {
  [BankConnectionErrorType.OpenBankingConnect]: 'bank_connection.connect_modal.open_banking.connect_error_description',
  [BankConnectionErrorType.OpenBankingMerge]: 'bank_connection.connect_modal.open_banking.merge_error_description',
}
